import React from 'react';
import data from '../data';
import '../cv.css';

function CV() {
  let out: React.JSX.Element[] = [];
  
  for (var type in data.cv) {
    let rows: React.JSX.Element[] = [];
    for (var i = 0; i < data.cv[type].items.length; i++) {
      var cv = data.cv[type].items[i];
      rows.push((
        <tr key={i}>
          <td className="date">{cv.date}</td>
          <td className="what">{cv.what}</td>
        </tr>
      ));
    }
    
    out.push(
      <div key={type}>
        <h2>{data.cv[type].header}</h2>
        <table>
          <tbody>
            {rows}
          </tbody>
        </table>
      </div>
    );
  }
  
  return (
    <div className="cv">
      <div dangerouslySetInnerHTML={{ __html: data.cvHeader }} />
      {out}
    </div>
  );
}

export default CV;